module.exports = __webpack_public_path__ + "images/right-tick.c905ac6c.webp";